export default __webpack_public_path__ + "static/media/Course-Icons1.6edbeea9.svg";